import React from "react";
import DefaultHelmet from "../../DefaultHelmet";

function Sent() {
    return (
        <>
            <DefaultHelmet
                title="Faites estimer votre bien immobilier"
                description="Obtenez une estimation immobilière rapide de votre appartement, maison ou commerce avec FOTI Immobilier. Expertise locale et sans engagement."
                og_description="Obtenez une estimation immobilière rapide de votre appartement, maison ou commerce avec FOTI Immobilier. Expertise locale et sans engagement."
            />
            <div className="container mx-auto w-11/12 md:w-4/5 h-full">
                <h2 className="flex flex-col text-xl md:text-2xl gap-y-6">
                    <p>Un expert vous contactera sous peu pour affiner les détails et vous fournir une estimation fiable et argumentée.</p>
                    <p className="font-bold italic">Ensemble, donnons à votre bien la valeur qu’il mérite.</p>
                </h2>
            </div>
        </>
    );
}

export default Sent;